//
// Used to avoid React re-render on non-primitive default props
//
const emptyObject = {};

export default emptyObject;
